import Vue from 'vue';
import axios from 'axios';
// import { recommendSwitch } from '@/store/api/recommend';

/**
 * 用户行为参数: actionType
 * rec_show; 用户浏览达观推荐结果, 上报
 * view;            浏览, 进入资源详情
 * rec_click;       点击达观推荐的结果
 * search;          搜索, 上报keyword(搜索关键字)
 * search_click;    点击搜索
 * share;           分享
 * collect;         收藏
 * comment;         评论
 * like;            点赞
 * unlike;          取消点赞
 * dislike;         不感兴趣
 * score;           评分
 * gift;            打赏
 * follow;          关注
 * unfollow;        取消关注
 * enrolling;       报名中课程
 * download;        知识点击下载
 * back;            关闭页面或退出应用,详情页面停留时间
 * paly;            视屏播放; 上报播放时长和播放完成度
 * learning;        学习中
 * finish;          学习完成
 */

/**
 {
     itemId: '',         物料id
     actionType: '',     用户行为
     sceneType: ''       模块业务类型
 }
 */

// const typeList = {
//     course: 0, // 课程
//     subject: 1, // 专题
//     live: 2, // 直播
//     knowledge: 3, // 知识
//     race: 4, // 竞赛
//     exam: 5, // 考试
//     survey: 6, // 调研
//     train: 7, // 培训
//     community: 8 // 纷享
// };

Vue.prototype.$buryPoint = function (payload) {
    const o = payload;
    const type = o.actionType;
    // 浏览达观推荐的结果, 上报推荐id
    // const recRequestId = type === 'rec_show' || type === 'rec_click' ? o.recRequestId : '';
    const url = '/zxy-log/recommend/user-action';
    const params = {
        itemId: o.id, // 产品id
        actionType: type, // 用户行为
        sceneType: o.sceneType || '', // 所属模块业务类型
        keyword: o.keyword || '', // 上报搜索关键词
        recRequestId: o.recRequestId,
        extra: JSON.stringify(o.actionDetail || {}), // 扩展数据
    };

    // 上传埋点数据
    axios.post(url, params, {
        encode: true
    }).then(
        () => {},
        (err) => {
            // eslint-disable-next-line no-console
            console.log('err', err);
        }
    );

    // recommendSwitch().then(
    //     (r) => {
    //         // 埋点开关
    //         if (r.data.result) {
    //             // 上传埋点数据

    //         }
    //     },
    //     (err) => {
    //         // eslint-disable-next-line no-console
    //         console.log('err', err);
    //     }
    // );
};

Vue.prototype.$syncRecommendInfo = function (itemId) {
    const buryParam = {
        id: itemId, // 物料id
        actionType: 'search-click', // 用户行为
        sceneType: '',
        keyword: '', // 用户行为为search时, 上报搜索关键字
        recRequestId: '', // 浏览达观推荐结果时, 上报结果对应的Id
        palyTime: '' // 用户型为为play, 上报学习时长
    };
    this.$buryPoint(buryParam);
};
